<template>
    <form class="content-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group col-sm-12">
            <h4>Seleccionar campos</h4>
        </div>

        <div class="form-group col-sm-12">
            <label for="channels">Nombre de Canal</label>
        </div>

        <div :class="{'has-error': errors.name}" class="form-group col-sm-6"> 
           <el-select
                filterable
                clearable
                v-model="selected"
                :multiple="multiple"
                :multiple-limit="multipleLimit"
            >
                <el-option v-for="i in list" :key="i.id" :label="i.name" :value="i.id"></el-option>
            </el-select>
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>

         <div class="form-group col-sm-12">
            <label for="id_pages">Número de Ficha:</label>
        </div>

        <div :class="{'has-error': errors.name}" class="form-group col-sm-6">
            <input name="id_pages" type="number" id="id_pages" class="form-control" v-model="data.id_pages" v-on:change="changeTitle" />
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>

        <div :class="{'has-error': errors.name}" class="form-group col-sm-12">
            <label for="name">Nombre de Ficha:</label> 
        </div>

        <div class="form-group col-sm-6">
            <input maxlength="256" name="name" type="text" id="name" class="form-control" :value="data.name" disabled/>
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>

        <div class="form-group col-sm-12">
            <label for="status">Estado</label>
        </div>

        <div class="form-group col-sm-4">
            <input id="active" type="checkbox" value="1" />
            <label>¿Activo?</label>
        </div>

        <div class="form-group col-sm-12">
            <input class="btn btn-primary" type="submit" value="Guardar" />
            <a class="btn btn-default" href="/backend/canales-atencion-ficha">Cancelar</a>
        </div>
    </form>
</template>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        name: 'LandingCanalesAtencionFicha',
        data() {
            return {
                errors: {},
                data: {
                    "id_pages": "",
                    "name": ""
                }, 
                list: [],
                selected: this.value
            }
        },
        components: {
            ElSelect,
            ElOption
        },
        watch: {
            value: function (value) {
                this.selected = value;
            },
            selected: function (value) {
                this.$emit('input', value);
            }
        },
        mounted() {
            axios.get('backend/canales-atencion-ficha/channels').then((response) => {
                console.log(response);
                    if (response.status == 200) {
                        if (response.data.canal) {
                            this.list.name = response.data.canal;
                        }
                        else {
                            this.list.name = "";
                        }
                    }
                    else {

                    }
            });
        },
        created() {
        },
        methods: {
            changeTitle: function() {
            axios.get('/backend/tramites-sucursal-virtual/getdata/' + this.data.id_pages)
                .then((response) => {
                    console.log(response);
                    if (response.status == 200) {
                        if (response.data.page) {
                            this.data.name = response.data.page;
                        } else {
                            this.data.name = "";
                            alert("Ficha no existe.");
                        }
                    } else {
                        alert("Ficha no existe.");
                    }
                });
            }
        }
    }
</script>